import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesPhotoFormMain } from './modules/ui/Main';

const ServicesPhotoFormPage = (
  <SuspensePage>
    <PagesServicesPhotoFormMain />
  </SuspensePage>
);

export default ServicesPhotoFormPage;
